import TitleBorder from '@src/assets/images/elements/title-border.webp';

import "./style.scss";

const SectionTitle = ({ type , title , enTitle , noBorder = "" , button = "" , className}) => {
    const selectSectionTitleType = (type)=>{
        switch (type){
            case "0" : return(
                <>
                    <div className='section-title d-flex flex-row align-items-center justify-content-center'>
                        <div className='section-title-text'>{title}</div>
                        {/*{!noBorder ? <img src={TitleBorder} alt="border" width="250px"/> : null}*/}
                        {button && button}
                    </div>
                </>
            )
            break;
            case "1" : return(
                <>
                    <div className='section-title'>
                        <div className='section-title-center'>
                            <div className='section-title-right-line'></div>
                            <div>
                                <h3 className='section-title-text'>{title}</h3>
                            </div>
                            <div className='section-title-left-line'></div>

                        </div>
                    </div>
                </>
            )
                break;
            case "2" : return(
                <>
                    <div className='section-title flex-row justify-content-between justify-content-md-center w-100'>
                        <div>
                            <h3 className='section-title-text'>{title}</h3>
                        </div>
                        <div className='section-title-center-line w-100 mx-2 d-none d-md-inline-block'></div>
                        {button && <div> {button}</div>}
                    </div>
                    <div className='section-title-center-line w-100 d-md-none d-inline-block'></div>
                </>
            )
                break;
            case "3" : return(
                <>
                    <div className='section-title flex-row justify-content-between align-items-end w-100'>
                        <div>
                            <h3 className='section-title-text section-title-line '>{title}</h3>
                        </div>

                        {button && <div> {button}</div>}
                    </div>
                    <div className='section-title-center-line w-100 mt-1'></div>
                </>
            )
                break;
            case "4" : return(
                <>
                    <div className='section-title flex-row justify-content-center align-items-center w-100'>
                        <div className='section-title-right-line'></div>
                        <div className='section-title-text section-title-has-bg mb-0'>
                            <span className='zindex-1 text-white'>{title}</span>
                        </div>
                        <div className='section-title-left-line'></div>
                    </div>
                </>
            )
                break;
            case "5" : return(
                <>
                    <div className='section-title-box d-flex flex-column justify-content-between'>
                        <div className='section-title-box-text mb-0 pl-3'>
                            <span className='zindex-1 text-white'>{title}</span>
                        </div>
                        <div className={"d-flex align-items-end justify-content-between"}>
                            {button && <div> {button}</div>}
                            <span className="section-title-box-enTitle">{enTitle}</span>
                        </div>
                    </div>
                </>
            )
                break;
        }

    }
    return (
        <div className={className}>
        {selectSectionTitleType(type)}
            </div>
        );
    }
;
export default SectionTitle;